import React, { useEffect, useState } from 'react';
import { BrandPartner, getBrandPartners } from '../../api/payment/brand-live.api';
import { IndividualOrdererBadge } from '../brand-deal/orderer-badge';

// "Đang hợp tác với": doanh nghiệp creator đang chạy quảng cáo. Rỗng hoặc lỗi thì ẩn cả mục.

const BrandPartners: React.FC<{ userId?: string }> = ({ userId }) => {
  const [partners, setPartners] = useState<BrandPartner[]>([]);

  useEffect(() => {
    setPartners([]);
    if (!userId) return undefined;
    let alive = true;
    getBrandPartners(userId)
      .then((list) => alive && setPartners(list ?? []))
      .catch(() => alive && setPartners([]));
    return () => {
      alive = false;
    };
  }, [userId]);

  if (partners.length === 0) return null;

  return (
    <div className="px-3 pb-3 text-sm">
      <div className="mb-2 font-semibold">Đang hợp tác với</div>
      <ul className="flex flex-col gap-2">
        {partners.map((p) => (
          <li key={p.adAccountId} className="flex items-center gap-2">
            {p.logoUrl ? (
              <img src={p.logoUrl} alt="" className="h-8 w-8 rounded-full object-cover" />
            ) : (
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0057FF] text-[13px] font-bold text-white">
                {(p.businessName || '?').trim().charAt(0).toUpperCase()}
              </span>
            )}
            <span className="ui-text truncate">{p.businessName}</span>
            <IndividualOrdererBadge kind={p.ordererKind} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandPartners;
